import withStyles from '@mui/styles/withStyles'

export default withStyles(
	theme => ({
		root: {
			position: 'absolute',
			top: '100%',
			left: theme.spacing(1),
			margin: theme.spacing(-0.3, 0, 0, 0),
			fontSize: theme.spacing(1.5),
		},
	}),
	{ name: 'Form-ErrorMessage' },
)
